import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "allDisabledWarning", "shiftList"]

  connect() {
    this.updateDisabledStates()
  }

  selectionChanged() {
    this.updateDisabledStates()
  }

  updateDisabledStates() {
    const selectedDateShifts = new Set()

    // Collect all currently selected date+shift combinations
    this.radioTargets.forEach(radio => {
      if (radio.checked) {
        const key = `${radio.dataset.slotDate}-${radio.dataset.shiftId}`
        selectedDateShifts.add(key)
      }
    })

    // Track disabled state per card
    const cardDisabledCounts = {}
    const cardTotalCounts = {}

    // Disable/enable radios based on selections
    this.radioTargets.forEach(radio => {
      const isSelected = radio.checked
      const key = `${radio.dataset.slotDate}-${radio.dataset.shiftId}`
      const cardIndex = radio.dataset.cardIndex
      const dateShiftSelectedElsewhere = selectedDateShifts.has(key) && !isSelected

      radio.disabled = dateShiftSelectedElsewhere

      // Track counts per card
      if (!cardTotalCounts[cardIndex]) {
        cardTotalCounts[cardIndex] = 0
        cardDisabledCounts[cardIndex] = 0
      }
      cardTotalCounts[cardIndex]++
      if (dateShiftSelectedElsewhere) {
        cardDisabledCounts[cardIndex]++
      }

      // Style the parent label
      const label = radio.closest("label")
      if (label) {
        if (dateShiftSelectedElsewhere) {
          label.classList.add("opacity-50", "cursor-not-allowed")
          label.classList.remove("cursor-pointer", "hover:bg-gray-50")
        } else {
          label.classList.remove("opacity-50", "cursor-not-allowed")
          label.classList.add("cursor-pointer", "hover:bg-gray-50")
        }
      }
    })

    // Show/hide warnings for cards where all options are disabled
    this.allDisabledWarningTargets.forEach(warning => {
      const cardIndex = warning.dataset.cardIndex
      const total = cardTotalCounts[cardIndex] || 0
      const disabled = cardDisabledCounts[cardIndex] || 0
      const hasSelection = this.radioTargets.some(r => r.dataset.cardIndex === cardIndex && r.checked)

      // Show warning if all options are disabled and none is selected in this card
      if (total > 0 && disabled === total && !hasSelection) {
        warning.classList.remove("hidden")
      } else {
        warning.classList.add("hidden")
      }
    })
  }
}
